import "./Events.js";

GLOBAL.Message = Static(Events, {
    sockjs: null,
    reconnect: true,
    reconnectTimeout: 1000,
    url: null,
    index: null,
    status: "closed",
    sessionId: null,

    connect: function(options) {
        var self = this;

        options = Util.object(options);

        this.reconnect = Util.coalesce(options.reconnect, this.reconnect, true);
        this.reconnectTimeout = Util.coalesce(options.reconnectTimeout, this.reconnectTimeout, 1000);

        this.sockjs = new SockJS(this.url);

        this.status = "connecting";
        this.emit("connecting");

        this.sockjs.onopen = function() {
            console.log("Message connected");

            self.authorize();

            self.status = "connected";
            self.emit("connected");
        };

        this.sockjs.onmessage = function(args) {
            switch (args.type) {
                case "message":
                    var data;
                    var index;

                    try {
                        data = JSON.parse(args.data);
                    } catch (e) {
                        console.log(e);

                        data = null;
                    }

                    index = data.index;
                    data = data.data;

                    if (index) {
                        self.index = index;
                    }

                    if (typeof(data) == "object" && data && data.event) {
                        console.log(data.event, index, data.data);

                        self.emit(data.event, data.data);
                    } else {
                        self.emit("data", data);
                    }
                    break;
                default:
                    console.log("unknown type", args);
            }
        };

        this.sockjs.onclose = function() {
            console.log("Message closed");

            self.sockjs = null;

            if (self.reconnect) {
                setTimeout(function() {
                    self.connect();
                }, self.reconnectTimeout);
            }

            self.status = "closed";
            self.emit("closed");
        }
    },

    close: function() {
        this.reconnect = false;

        this.sockjs.close();
    },

    send: function(data) {
        this.sockjs.send(JSON.stringify(data));
    },

    authorize: function() {
        var data = {
            sessionId: this.sessionId
        };

        if (this.index) {
            data.index = this.index;
        }

        this.send({
            name: "authorize",
            data: data
        });
    }
});
